import { render, staticRenderFns } from "./Recordings.vue?vue&type=template&id=191a4b7e&scoped=true&"
import script from "./Recordings.vue?vue&type=script&lang=js&"
export * from "./Recordings.vue?vue&type=script&lang=js&"
import style0 from "./Recordings.vue?vue&type=style&index=0&id=191a4b7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191a4b7e",
  null
  
)

export default component.exports